var _path, _circle;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.697949 16.025L3.37402 12.5L0.695801 8.97214C0.977031 8.06308 1.37189 7.17099 1.88528 6.31353C2.39867 5.45607 3.00242 4.68029 3.67824 3.9909L8.18572 4.46354L10.0135 0.46625C11.9487 0.0197355 13.9931 0.00409991 15.9796 0.462553L17.8091 4.46354L22.3171 3.99084C23.7221 5.42054 24.7303 7.13567 25.2969 8.97497L22.6208 12.5L25.299 16.0279C25.0178 16.9369 24.6229 17.829 24.1096 18.6865C23.5962 19.5439 22.9924 20.3197 22.3166 21.0091L17.8091 20.5365L15.9813 24.5337C14.0462 24.9803 12.0017 24.9959 10.0152 24.5374L8.18572 20.5365L3.67769 21.0092C2.2727 19.5795 1.26451 17.8643 0.697949 16.025Z",
    fill: "#3585F9"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 12,
    r: 5,
    fill: "#F6F6F6"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/Support.b553ee78a604c8c1119741ddbf555cd1.svg";
export { ForwardRef as ReactComponent };